/// <amd-module name="Artifacts/Connect/hooks/ListRouting" />
import { IToolTabCell } from "Artifacts/Connect/components/ConnectToFeed";
import { IConnectToFeedParams } from "Artifacts/Root/routing/Types";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { IItemProvider } from "VSSUI/Utilities/Provider";

/**
 * Effect hook that synchronizes URL route and selected tool.
 * Route to specific tool built by appending tool id to connect to feed route.
 * The initial page load navigated via direct link will select the tool from the list.
 * The url will not change when switching tools (tabs).
 * @param toolsItemProvider Tools list item provider.
 * @param selection Selection object for tools list.
 * @param selectTool Callback that changes selected tool programmatically.
 */
export function useToolsListRouting(
  toolsItemProvider: IItemProvider<IToolTabCell>,
  selectTool: (toolId: string) => void,
): void {
  const location = useLocation();
  const { feedIdentifier, toolId } = useParams<IConnectToFeedParams>();

  // Select tool from the list if navigated via direct link
  useEffect(() => {
    if (toolId) {
      const toolItem = toolsItemProvider.value.find(
        (item) => item.tool?.name.toLocaleLowerCase() === toolId.toLocaleLowerCase(),
      );
      toolItem?.tool && selectTool(toolItem.tool.name);
    }
  }, [location, selectTool, toolsItemProvider, toolId]);
}
